import "core-js";
import "core-js/stable";
import "regenerator-runtime/runtime";
import "url-search-params-polyfill";

import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import { pinia } from "@/store/index";
import router from "./router";
import i18n from "./i18n";
import VueCookies from "vue-cookies";
import Notifications from "@kyvg/vue3-notification";

// import "@/assets/sass/custom.scss";
import "@/assets/styles/app.scss";
// Иконочные шрифты — через JS, не через SCSS @import (фикс потери @font-face)
import "@fortawesome/fontawesome-free/css/all.css";
import "material-icons/iconfont/material-icons.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import { second, minute } from "@/services/date-time/time-controll";
import { getImage, getWebImage } from "@/services/getImage";
import { getLocale } from "@/services/locales";
import { getDeviceType } from "@/services/device-type";
import { errorLoger } from "@/services/axios-errors";
import { getCoast } from "@/services/coast-formation";
import axiosInstance from "@/api/authorization/auth-request-api";

const app = createApp(App)
  .use(router)
  .use(i18n)
  .use(pinia)
  .use(VueCookies, { expires: "7d" })
  .use(Notifications);

app.config.globalProperties.$second = second;
app.config.globalProperties.$minute = minute;
app.config.globalProperties.$getImage = getImage;
app.config.globalProperties.$getLocale = getLocale;
app.config.globalProperties.$getWebImage = getWebImage;
app.config.globalProperties.$deviceType = getDeviceType;
app.config.globalProperties.$error = errorLoger;
app.config.globalProperties.$getCoast = getCoast;
app.config.globalProperties.$axios = axiosInstance;
app.config.globalProperties.$hotel = process.env.VUE_APP_HOTEL || "ship";

app.mount("#app");
